import React, { useContext, useState, useEffect, useMemo, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
import { provider } from 'web3-core'

import Value from '../../components/Value/OnlyValue'
import { Input as NumericalInput } from '../../components/NumericalInput'
import { ButtonLight, ButtonPrimary, ButtonConfirmed } from '../../components/Button'
import Row, { AutoRow } from '../../components/Row'
import Loader from '../../components/Loader'
// import NftPreviewModal from '../../components/Gamification/NftPreviewModal'
import Modal from '../../components/bakery/Modal'

import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useAllowance from '../../hooks/bakery/useAllowance'
import useYam from '../../hooks/bakery/useYam'
import useApprove from '../../hooks/bakery/useApprove'
import useSynthesis from '../../hooks/nft/useSynthesis'
import useBakerySoccerRoi from '../../hooks/nft/useBakerySoccerRoi'
import useBlockNum from '../../hooks/bakery/useBlockNum'
import useBlock from '../../hooks/bakery/useBlock'
import { usePrice } from '../../hooks/usePrice'
import useInterval from '../../hooks/useInterval'
import useModal from '../../hooks/bakery/useModal'
import usePokerCardRoi from '../../hooks/nft/usePokerCardRoi'

import { NFTTYPE } from '../../constants/bakery/nft'
import {
  getSoccerAddress,
  getBakerySoccerMasterContract,
  getSoccerPokerGameBoxContract,
  getSoccerPokerGameBoxMintInfo,
  getPokerAddress,
  getWethContract,
  getPetBnbBlpContract,
  getPetContract,
  getAliceBnbBlpContract,
  getAliceContract,
  getTlmBnbBlpContract,
  getTlmContract,
  getPokerBlindBoxContract,
  getCarAddress,
  getCarBlindBoxContract,
  getCarBnbBlpContract,
  getCarContract,
  getPokerBnbBlpContract,
  getPokerContract
} from '../../sushi/utils'

import { BigNumber } from '../../sushi'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import { getContract } from '../../utils/bakery/erc20'
import { BIGNUMBER_FMT } from '../../constants/bakery'

const FormWrapper = styled.div<{ pad?: string }>`
  background: ${({ theme }) => theme.bsBg6};
  box-shadow: 0px 2px 10px ${({ theme }) => (theme.darkMode ? 'transparent' : 'rgba(171, 133, 115, 0.16)')};
  border-radius: 20px;
  width: 432px;
  max-height: 305px;
  padding: ${({ pad }) => (pad ? pad : '16px 48px 20px')};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 16px 28px 20px;
    width: 90%;
    margin: 30px auto;
  `};
`
const AttachRow = styled.div<{ marginBottom?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.bsText3};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : 0)}px;
  .label {
    margin-left: 3px;
    font-size: 13px;
    font-family: no;
    color: ${({ theme }) => theme.bsText3};
  }
`
const AttachBtnRow = styled(AttachRow)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    .btn {
      margin-right: 0px!important;
      &:last-child {
        margin-top: 10px;
      }
    }
    .text {
      margin-left: 0px!important;
    }
  `};
`
const ValueItem = styled.div`
  display: flex;
  align-items: center;
  max-width: 150px;
`
const RowInput = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg5};
  border: 1px solid ${({ theme }) => theme.bsBorder1};
  border-radius: 10px;
  height: 40px;
  padding: 0 16px;
  & > input {
    font-size: 18px;
    font-family: 'Baloo Da';
  }
`
const AttachWrapper = styled.div<{ mar?: string }>`
  margin: ${({ mar }) => (mar ? mar : '0.5rem 0 1rem')};
`
const MyDishes = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.bsText7};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary1};
  font-family: Baloo Da;
  height: 32px;
  text-decoration: none;
  margin-top: 10px;
`
const Tips = styled.div`
  background: rgba(217, 64, 64, 0.1);
  padding: 7px 8px;
  border-radius: 6px;
  display: flex;
  /* height: 51px; */
  align-items: flex-start;
  margin-bottom: 17px;
  margin-top: 7px;
  img {
    margin-right: 10px;
    margin-top: -5px;
  }
`
// const BuyBtn = styled(ButtonConfirmed)`
//   margin: 11px 0 2px;
//   width: 50%;
//   flex-shrink: 1;
//   font-size: 14px;
//   padding: 0;
//   height: 32px;
//   border-radius: 8px;
//   color: ${({ theme }) => theme.bsText8};
//   &:first-child {
//     margin-right: 16px;
//   }
// `

const BtnStatus = ({
  type,
  tokenBalance,
  bakeAmount,
  stakeToken,
  getToken,
  curNum
}: {
  type: string
  tokenBalance: number
  bakeAmount: string
  stakeToken: any
  getToken: any
  curNum?: number
}) => {
  const sushi = useYam()
  const { account, library } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const ethereum = library?.provider
  const theme = useContext(ThemeContext)

  const right = type === 'GAMEBOXSOCCER' ? 18 : 0

  let isGameBox = false
  if (type && ['GAMEBOXSOCCER', 'GAMEBOXPOKER'].includes(type)) {
    isGameBox = true
  }

  let lpTokenAddress: string
  let masterContract: any
  switch (type) {
    case NFTTYPE.SOCCER:
      lpTokenAddress = getSoccerAddress(sushi)
      masterContract = getBakerySoccerMasterContract(sushi)
      break
    case NFTTYPE.POKER:
      lpTokenAddress = getPokerAddress(sushi)
      masterContract = getPokerBlindBoxContract(sushi)
      break
    case NFTTYPE.CAR:
      lpTokenAddress = getCarAddress(sushi)
      masterContract = getCarBlindBoxContract(sushi)
      break
    case 'GAMEBOXSOCCER':
      lpTokenAddress = getSoccerAddress(sushi)
      masterContract = getSoccerPokerGameBoxContract(sushi)
      break
    case 'GAMEBOXPOKER':
      lpTokenAddress = getPokerAddress(sushi)
      masterContract = getSoccerPokerGameBoxContract(sushi)
      break
  }
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ethereum])
  const allowance = useAllowance(lpContract, masterContract)

  const [notStarted] = useModal(
    <Modal backgroundColor={theme.bsBg1}>
      <Text style={{ margin: '30px auto 20px', fontSize: '17px', fontFamily: 'Yuanti SC', fontWeight: 'bold' }}>
        Not Started
      </Text>
    </Modal>
  )

  const [requestedApproval, setRequestedApproval] = useState(false)
  const { onApprove } = useApprove(lpContract, masterContract)
  const handleApprove = useCallback(async () => {
    if (isGameBox && curNum && curNum < 6950985) {
      notStarted()
      return
    }
    try {
      setRequestedApproval(true)
      const txHash = await onApprove()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedApproval(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApprove, setRequestedApproval, curNum, isGameBox, notStarted])

  const [allowanceMake, setAllowanceMake] = useState<boolean>(false)
  useEffect(() => {
    const isAllowance = new BigNumber(bakeAmount).lte(tokenBalance)
    setAllowanceMake(isAllowance)
  }, [tokenBalance, bakeAmount])

  // Make dish
  const [pendingTx, setPendingTx] = useState(false)
  const { onSynthesis } = useSynthesis(isGameBox ? NFTTYPE.GAMEBOX : type)
  const makeMyDish = useCallback(async () => {
    if (isGameBox && curNum && curNum < 6950985) {
      notStarted()
      return
    }
    try {
      setPendingTx(true)
      const txHash = await onSynthesis(isGameBox ? lpTokenAddress : bakeAmount)
      // synthesis dish success
      if (txHash) {
        console.log('txHash', txHash)
      }
    } catch (e) {
      console.log(e)
    }
    setPendingTx(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bakeAmount, onSynthesis, type, curNum, isGameBox, notStarted])

  // 获取已经mint的数据
  const [mintInfo, setMintInfo] = useState({
    0: '',
    1: '',
    2: '',
    3: '',
    poker: '',
    soccer: '',
    userPoker: '',
    userSoccer: ''
  })
  const fetchGameBoxMintInfo = useCallback(async () => {
    const info: any = await getSoccerPokerGameBoxMintInfo(masterContract, account)
    setMintInfo(info)
  }, [account, masterContract])

  useEffect(() => {
    if (isGameBox && account) {
      fetchGameBoxMintInfo()
    }
  }, [account, type, masterContract, fetchGameBoxMintInfo, isGameBox])

  useInterval(
    () => {
      fetchGameBoxMintInfo()
    },
    account && isGameBox ? 10000 : null
  )

  const Btn = () => {
    // 链接钱包
    if (!account) {
      return (
        <ButtonLight height={isGameBox ? 32 : 40} marginRight={right} onClick={toggleWalletModal}>
          Connect Wallet
        </ButtonLight>
      )
    }

    // 还未开始
    // if (['POKER'].includes(stakeToken) && !isGameBox) {
    //   return (
    //     <ButtonConfirmed height={32} padding="0px 18px">
    //       Coming Soon !
    //     </ButtonConfirmed>
    //   )
    // }

    if (
      isGameBox &&
      ((type === 'GAMEBOXPOKER' && +mintInfo.poker >= 500) || (type === 'GAMEBOXSOCCER'))
    ) {
      return (
        <ButtonConfirmed
          disabled={true}
          altDisabledStyle={true}
          marginRight={right}
          height={32}
          padding="0px 5px"
          className="btn"
          fontSize={14}
        >
          Sold out for {stakeToken}
        </ButtonConfirmed>
      )
    }

    // 授权 NFT
    if (!allowance.toNumber()) {
      if (isGameBox && curNum && curNum < 6950985) {
        return ( 
          <ButtonConfirmed
            onClick={handleApprove}
            marginRight={right}
            height={32}
            padding="0px 5px"
            className="btn"
            fontSize={14}
          >
            Burn 0.25 {stakeToken} to get 1
          </ButtonConfirmed>
        )
      }
      return (
        <ButtonConfirmed
          onClick={handleApprove}
          disabled={requestedApproval}
          altDisabledStyle={isGameBox && requestedApproval}
          width="100%"
          marginRight={right}
          height={32}
          padding="0px 5px"
          className="btn"
          fontSize={isGameBox ? 14 : 16}
        >
          {requestedApproval ? (
            <AutoRow gap="6px" justify="center">
              Approving <Loader stroke="white" />
            </AutoRow>
          ) : isGameBox ? (
            type === 'GAMEBOXSOCCER' ? (
              'Burn 0.25 Soccer to get 1'
            ) : (
              'Burn 0.25 Poker to get 1'
            )
          ) : (
            'Approve ' + stakeToken
          )}
        </ButtonConfirmed>
      )
    }

    // creat NFT
    if (allowance.toNumber()) {
      return (
        <ButtonPrimary
          disabled={
            !allowanceMake ||
            pendingTx ||
            (type === 'GAMEBOXPOKER' && +mintInfo.userPoker >= 1) ||
            (type === 'GAMEBOXSOCCER' && +mintInfo.userSoccer >= 1)
          }
          altDisabledStyle={
            !allowanceMake ||
            (type === 'GAMEBOXPOKER' && +mintInfo.userPoker >= 1) ||
            (type === 'GAMEBOXSOCCER' && +mintInfo.userSoccer >= 1)
          }
          marginRight={right}
          height={32}
          padding="0px 5px"
          className="btn"
          fontSize={isGameBox ? 14 : 16}
          onClick={makeMyDish}
        >
          {(type === 'GAMEBOXPOKER' && +mintInfo.userPoker >= 1) ||
          (type === 'GAMEBOXSOCCER' && +mintInfo.userSoccer >= 1) ? (
            'Only one for ' + stakeToken
          ) : !bakeAmount || allowanceMake ? (
            pendingTx ? (
              <AutoRow gap="6px" justify="center">
                Making <Loader stroke="white" />
              </AutoRow>
            ) : isGameBox ? (
              type === 'GAMEBOXSOCCER' ? (
                'Burn 0.25 Soccer to get 1'
              ) : (
                'Burn 0.25 Poker to get 1'
              )
            ) : (
              'Get my ' + getToken + ' !'
            )
          ) : isGameBox ? (
            type === 'GAMEBOXSOCCER' ? (
              'Burn 0.25 Soccer to get 1'
            ) : (
              'Burn 0.25 Poker to get 1'
            )
          ) : (
            'Insufficient ' + stakeToken + ' balance'
          )}
        </ButtonPrimary>
      )
    }

    return null
  }

  return <Btn />
}

const MyDishesStatus = ({ stakeToken, getToken, curNum }: { stakeToken: any; getToken: any; curNum?: number }) => {
  if (['GAMEBOX'].includes(stakeToken)) {
    if (curNum && curNum <= 6950985) {
      return <MyDishes to={'/gamification/gameBox'}>#Blocks Left: {6950985 - curNum}</MyDishes>
    } else {
      return <MyDishes to={'/my-game-box'}>My {getToken}s</MyDishes>
    }
  } else if (['POKER'].includes(stakeToken)) {
    return (
      <MyDishes to={'/myArtwork/poker'}>My {getToken}s</MyDishes>
      // <MyDishes to={'/gamification/poker'}>My {getToken}s</MyDishes>
    )
  } else if (['CAR'].includes(stakeToken)) {
    return <MyDishes to={'/myArtwork/car'}>My {getToken}s</MyDishes>
  } else {
    return <MyDishes to={'/myArtwork/soccer'}>My {getToken}s</MyDishes>
  }
}

export default function CreatGameBox({ type, curNum }: { type: string; curNum?: number }) {
  const theme = useContext(ThemeContext)
  const { account } = useActiveWeb3React()

  // token balance
  let address
  let stakeToken
  let getToken
  let address2
  const yam = useYam()
  switch (type) {
    case NFTTYPE.SOCCER:
      address = getSoccerAddress(yam)
      stakeToken = 'Soccer'
      getToken = 'Soccer NFT'
      break
    case NFTTYPE.POKER:
      address = getPokerAddress(yam)
      stakeToken = 'POKER'
      getToken = 'Poker BlindBox NFT'
      break
    case NFTTYPE.CAR:
      address = getCarAddress(yam)
      stakeToken = 'CAR'
      getToken = 'CAR NFT'
      break
    case NFTTYPE.GAMEBOX:
      address = getSoccerAddress(yam)
      stakeToken = 'GAMEBOX'
      getToken = 'BSC Game Box NFT'
      address2 = getPokerAddress(yam)
      break
  }
  const [tokenBalance, setTokenBalance] = useState(0)
  const bakeryBalance = useTokenBalance(address)
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    const balanceFormat = new BigNumber(balance).decimalPlaces(3, 1).toNumber()
    setTokenBalance(balanceFormat)
  }, [bakeryBalance])

  // PokerBalance
  const [tokenBalance2, setTokenBalance2] = useState(0)
  const bakeryBalance2 = useTokenBalance(address2)
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance2)
    const balanceFormat = new BigNumber(balance).decimalPlaces(3, 1).toNumber()
    setTokenBalance2(balanceFormat)
  }, [bakeryBalance2])

  const [bakeAmount, setBakeAmount] = useState('')
  const onUserInput = (val: string) => {
    const text: string = val.replace(/^0+/g, '').replace(/[^\d]/g, '')
    setBakeAmount(text)
  }

  const currentBlock = useBlock()
  const blockNum = useBlockNum(currentBlock)
  const soccerRoi = useBakerySoccerRoi(blockNum as BigNumber)
  const pokerBnbPrice = usePrice(getPokerBnbBlpContract(yam), getPokerContract(yam), getWethContract(yam))
  const pokerBnbPriceFormat = pokerBnbPrice ? pokerBnbPrice.toNumber() : 0
  const pokerRoi = usePokerCardRoi(currentBlock, NFTTYPE.POKER_V3, 12000, pokerBnbPriceFormat)
  const carBnbPrice = usePrice(getCarBnbBlpContract(yam), getCarContract(yam), getWethContract(yam))
  const transformBnbPrice = carBnbPrice ? carBnbPrice.toNumber() : 0
  const carRoi = usePokerCardRoi(currentBlock, NFTTYPE.CAR_V3, 100, transformBnbPrice)
  let roi
  switch (type) {
    case NFTTYPE.SOCCER:
      roi = soccerRoi
      break
    case NFTTYPE.POKER:
      roi = pokerRoi
      break
    case NFTTYPE.CAR:
      roi = carRoi
      break
  }

  const sushi = useYam()
  const tlmBnbPrice = usePrice(getTlmBnbBlpContract(sushi), getTlmContract(sushi), getWethContract(sushi))
  const aliceBnbPrice = usePrice(getAliceBnbBlpContract(sushi), getAliceContract(sushi), getWethContract(sushi))
  const petBnbPrice = usePrice(getPetBnbBlpContract(sushi), getPetContract(sushi), getWethContract(sushi))
  const [bnbAmount, setBnbAmount] = useState(0)
  useEffect(() => {
    const num =
      (tlmBnbPrice ? tlmBnbPrice.toNumber() : 0) * 1500 +
      (aliceBnbPrice ? aliceBnbPrice.toNumber() : 0) * 20 +
      (petBnbPrice ? petBnbPrice.toNumber() : 0) * 20
    setBnbAmount(num)
  }, [tlmBnbPrice, aliceBnbPrice, petBnbPrice])

  return (
    <FormWrapper pad={type === NFTTYPE.GAMEBOX ? '19px 28px 12px' : ''}>
      {type !== NFTTYPE.GAMEBOX ? (
        <>
          <AttachRow style={{ marginBottom: 8 }}>
            <Text fontSize={12} fontWeight={700}>
              Balance:
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              <ValueItem>
                <Value decimals={3} value={tokenBalance} /> &nbsp;{stakeToken}
              </ValueItem>
            </Text>
          </AttachRow>
          <RowInput>
            <NumericalInput
              className="token-amount-input"
              value={bakeAmount}
              style={{ marginRight: 5 }}
              placeholder={'0'}
              maxLength={12}
              onUserInput={val => {
                onUserInput(val)
              }}
            />
            <Text fontWeight={700}>{stakeToken}</Text>
          </RowInput>
          <AttachRow marginBottom={5}>
            <Text fontSize={12} fontWeight={700}>
              You will get :{' '}
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              <ValueItem>
                <Value decimals={0} value={bakeAmount} /> &nbsp;{getToken}
              </ValueItem>
            </Text>
          </AttachRow>
        </>
      ) : (
        <>
          <AttachRow marginBottom={8}>
            <Text fontSize={13} fontWeight={700}>
              Tokens in each Box :{' '}
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              TLM*1500 + ALICE*20 + PET*20
            </Text>
          </AttachRow>
          <AttachRow marginBottom={15}>
            <Text fontSize={13} fontWeight={700}>
              Current Values of Tokens in each Box :{' '}
            </Text>
            <Text
              fontSize={14}
              color={theme.bsText7}
              fontWeight={700}
              fontFamily={'Baloo Da'}
              style={{ marginLeft: 8 }}
            >
              <ValueItem>
                <Value decimals={8} value={bnbAmount} /> &nbsp;<span className="label">BNB</span>
              </ValueItem>
            </Text>
          </AttachRow>
          <AttachBtnRow>
            <BtnStatus
              type="GAMEBOXSOCCER"
              tokenBalance={tokenBalance}
              bakeAmount="0.25"
              stakeToken="Soccer"
              getToken={getToken}
              curNum={curNum}
            />
            <BtnStatus
              type="GAMEBOXPOKER"
              tokenBalance={tokenBalance2}
              bakeAmount="0.25"
              stakeToken="Poker"
              getToken={getToken}
              curNum={curNum}
            />
          </AttachBtnRow>
          <AttachBtnRow>
            <Row>
              <Text fontSize={13} fontWeight={700}>
                Balance:
              </Text>
              <Text
                fontSize={14}
                color={theme.bsText7}
                fontWeight={700}
                fontFamily={'Baloo Da'}
                style={{ marginLeft: 8 }}
              >
                <ValueItem>
                  <Value decimals={3} value={tokenBalance} /> &nbsp;<span className="label">Soccer</span>
                </ValueItem>
              </Text>
            </Row>
            <Row>
              <Text className="text" fontSize={13} fontWeight={700} marginLeft={16}>
                Balance:
              </Text>
              <Text
                fontSize={14}
                color={theme.bsText7}
                fontWeight={700}
                fontFamily={'Baloo Da'}
                style={{ marginLeft: 8 }}
              >
                <ValueItem>
                  <Value decimals={3} value={tokenBalance2} /> &nbsp;<span className="label">Poker</span>
                </ValueItem>
              </Text>
            </Row>
          </AttachBtnRow>
        </>
      )}
      <AttachWrapper mar={type === NFTTYPE.GAMEBOX ? '19px 0 10px' : ''}>
        {type !== NFTTYPE.GAMEBOX && (
          <>
            <AttachRow marginBottom={5}>
              <Text fontSize={12} fontWeight={700}>
                Average APY:
              </Text>
              <Text
                fontSize={14}
                color={theme.bsText7}
                fontWeight={700}
                fontFamily={'Baloo Da'}
                style={{ marginLeft: 8 }}
              >
                {roi && !roi.isNaN() && roi.gt(0)
                  ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%'
                  : '-'}
              </Text>
            </AttachRow>
            <Tips>
              <img src="/images/nft/icon_soccer_tips.svg" alt="" />
              <Text fontSize={13} color={'#D94040'}>
                Note that {getToken}s can NOT be transformed back to {stakeToken} Tokens!
              </Text>
            </Tips>
            <BtnStatus
              type={type}
              tokenBalance={tokenBalance}
              bakeAmount={bakeAmount}
              stakeToken={stakeToken}
              getToken={getToken}
            />
          </>
        )}
        {!!account && <MyDishesStatus stakeToken={stakeToken} getToken={getToken} curNum={curNum} />}
      </AttachWrapper>
      {/* <NftPreviewModal isOpen={modalOpen} onDismiss={handleDismissSearch} dish={''} /> */}
    </FormWrapper>
  )
}
